/* eslint-disable import/prefer-default-export */
/* eslint-disable lines-between-class-members */

import { NextAppRouteInst } from './types'

/**
 * TODO:
 * 1. Add method to create url from route pathname
 */
export class NextAppRoute<
  Path extends string,
  BasePath extends string | undefined = undefined,
  Pathname extends string = BasePath extends undefined ? Path : `${BasePath}${Path}`
> implements NextAppRouteInst<Path, BasePath, Pathname>
{
  readonly path: Path
  readonly pathname: Pathname

  constructor({ path, basePath }: { path: Path; basePath?: BasePath }) {
    this.path = path
    this.pathname = (basePath ? `${basePath}${path}` : path) as Pathname
  }

  isActive = (activePath: string) => {
    return activePath.endsWith(this.pathname)
  }
}
